import React from 'react'
import { useSelector } from 'react-redux'
import { SvgIcon } from '@mui/material'
import {  Lightbulb, LightbulbOutlined } from '@mui/icons-material'
import { ratingIcons } from 'keys/rating'
import NoDataSection from './NoDataSection'

// תיווך נדרש לפי דירוג (מהעיצוב) — עבור 3 הדירוגים הנמוכים
const accommodationByTier = {
    3: { level: 'הנגשה נקודתית של משימות או תוספת זמן', tag: 'תיווך בכיתה' },
    4: { level: 'תיווך ברוב המקצועות הנלמדים' },
    5: { level: 'ליווי פרטני של הלמידה'},
    
    // 4: { level: 'תיווך ברוב המקצועות הנלמדים', tag: 'תיווך בכיתה וליווי פרטני' },
    // 5: { level: 'ליווי פרטני של הלמידה', tag: 'ליווי פרטני' },
}

// שקף 5 — הצעדים הבאים להתאמת הלמידה: צרכים מול מענים
const Slide5NextSteps = ({ data }) => {
    const { brokenDisplay } = useSelector(state => state.general)
    const { needsCount, strugglingTiers, completionRate, executedStudents, totalStudents } = data

    return (
        <div className='steps-layout'>
            <div className='info-callout'>
                <SvgIcon component={LightbulbOutlined} className='callout-icon' />
                <div>
                    {'תלמיד המתקשה בקריאה זקוק '}
                    <b>{'להתאמת למידה בכיתה'}</b>
                    {' כדי לעמוד בקצב '}
                    <b>{'ולהתערבות לקידום הקריאה'}</b>
                    {' כדי לצמצם את הפערים ולהגיע לרמת בני גילו.'}
                </div>
            </div>

            <div className='numbered-section'>
                <div className='numbered-section-header'>
                    <div className='section-number'>{'01'}</div>
                    <div className='section-title'>{'התאמת הלמידה - צרכים'}</div>
                    <div className={`section-total`}><span className={`${brokenDisplay && 'blurred2'}`}>{needsCount.toLocaleString()}</span>{` תלמידים`}</div>
                </div>
                <div className='slide-subtitle'>
                    {'לתלמידים בדירוגים השונים צרכים שונים של התאמת למידה על מנת להתקדם עם הכיתה, למנוע פערי ידע ולקבל תחושת מסוגלות.'}
                </div>
                <div className='tier-needs-cards'>
                    {strugglingTiers?.map(tier => (
                        <div key={tier.index} className='tier-needs-card' style={{ backgroundColor: `${tier.cardBgColor}` }}>
                            <div className='tier-needs-header'>
                                <span className='tier-chip' style={{ backgroundColor: tier.labelBg, color: tier.textColor, fontWeight: 400 }}>
                                    <i className={ratingIcons[tier.index - 1]} />
                                    {tier.label}
                                </span>
                                <span style={{ color: tier.textColor }}><span className={`${brokenDisplay && 'blurred2'}`}>{tier.count.toLocaleString()}</span>{` תלמידים`}</span>
                            </div>
                            <div>
                                <b>{'רמת התאמת הלמידה:'}</b>
                                <div>{accommodationByTier[tier.index]?.level}</div>
                            </div>
                           { accommodationByTier[tier.index]?.tag && <div className='tier-chip' style={{ backgroundColor: `${tier.color}66`, color: tier.textColor, alignSelf: 'stretch', justifyContent: 'center' }}>
                                {accommodationByTier[tier.index]?.tag}
                            </div>}
                        </div>
                    ))}
                </div>
            </div>

            <div className='numbered-section'>
                <div className='numbered-section-header'>
                    <div className='section-number'>{'02'}</div>
                    <div className='section-title'>{'התאמת למידה - מענים'}</div>
                    {/* {totalStudents > 0 &&
                        <div className='section-total'>{`${completionRate}% ביצוע`}</div>} */}
                </div>
                {totalStudents > 0 ?
                    <div className='slide-subtitle'>
                        טרם הוזנו נתונים
                        {/* {`${executedStudents.toLocaleString()} מתוך ${totalStudents.toLocaleString()} תלמידים סיימו לבצע את סוללת המבדקים.`} */}
                    </div>
                    :
                    <NoDataSection />}
            </div>
        </div>
    )
}

export default Slide5NextSteps
